<template>
  <div class="entryGoods">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <div class="entery_title">
        <div class="line"></div>
        <div class="base_title">基本信息</div>
      </div>
      <div class="cross">
        <el-form-item label="商品类目" prop="ctgId">
          <el-select v-model="ruleForm.ctgId" placeholder="请选择商品类目">
            <el-option :label="item.name" v-for="(item, index) in list" :key="index" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入商品名称（最多40个字符）"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="商品主图" prop="mainImgs">
        <div class="phone_info">建议您上传 5张750*750px的实拍大图，包含商品整体款式和商品细节，白色背景最佳，图片小于10MB，支持JPG、JPEG和PNG格式
        </div>

        <ul class="uploads">

          <li class="phone_info">
            <el-upload class="avatar-uploader" action accept=".jpg, .png, .jpeg" :show-file-list="false"
              :before-upload="beforeAvatarUpload" :http-request="uploadSectionFile" ref="mianImgs">
              <div class="avatar-uploader-text">
                <img src="../../../assets/img/3dshopping/shangchuan1.png" style="height:32px;width:32px" />
                <div>上传封面图</div>
              </div>
            </el-upload>
          </li>
          <li class="li_upload" v-for="(item, index) in imageList" :key="index">
            <div v-if="item" class="avatar">
              <img :src="item" />
              <i @click="delIcon(index)" class="el-icon-error"></i>
            </div>
          </li>
        </ul>

      </el-form-item>
      <el-form-item label="关联商品3D" prop="region">
        <div class="good_model">
          <div class="good_model_img" v-if="threeD.thumbnail">
            <img :src="threeD.thumbnail" />
            <div class="maskBox" @click="addModel_show">重新上传</div>

            <div class="codeInfo">
              <div>code:{{ threeD.code }}</div>
              <!--<div v-show="ruleForm.id">商品编码:{{ruleForm.id}}</div>-->
            </div>
          </div>

          <div v-else class="good_model_itme" @click="addModel_show">
            <img src="../../../assets/img/3dshopping/moxing1.png" style="height:32px;width:32px" />
            <div>添加商品模型</div>
          </div>
        </div>
      </el-form-item>
      <div class="cross" v-if="ruleForm.id">
        <el-form-item label="商品编码">
          <span>{{ ruleForm.id }}</span>
        </el-form-item>
      </div>

      <div class="entery_title" v-if="offRetailStore">
        <div class="line"></div>
        <div class="base_title">分销设置</div>
        <div class="fuwenben">(请谨慎选择分销比例的设置，它将记录分销的金额)</div>
      </div>

      <div class="cross" v-if="offRetailStore">
        <el-form-item label="是否进行分销">
          <el-switch v-model="ruleForm.offDistribution"></el-switch>
        </el-form-item>
        <el-form-item label="分销类型" v-if="ruleForm.offDistribution">
          <el-radio-group v-model="ruleForm.distributionType">
            <el-radio :label="1">百分比</el-radio>
            <el-radio :label="2">固定金额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分销比例" prop="Distribution" v-if="ruleForm.offDistribution">
          <el-input v-model="ruleForm.distribution" placeholder="请输入内容"></el-input>
          <span v-if="ruleForm.distributionType == '2'" style="color: red; margin-left: 20px;">元</span>
          <span v-if="ruleForm.distributionType == '1'" style="color: red; margin-left: 20px;">%</span>
        </el-form-item>
      </div>

      <div class="entery_title">
        <div class="line"></div>
        <div class="base_title">销售信息</div>
      </div>

      <div class="cross">
        <el-form-item label="计量单位" prop="mmUnit">
          <!-- <el-input v-if="addOrEditor" v-model="ruleForm.mmUnit" placeholder="请选择计量单位"></el-input> -->
          <el-select v-model="ruleForm.mmUnit" placeholder="请选择计量单位">
            <el-option v-for="(item, index) in unitList" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展示价格">
          <el-switch v-model="ruleForm.offCustRetail"></el-switch>
        </el-form-item>
        <el-form-item label="销售单价" prop="custRetail">
          <el-input class="mainum_input" v-model="ruleForm.custRetail" placeholder="请输入销售单位"></el-input>
          元 / 每{{ unit }}
        </el-form-item>
      </div>
      <el-form-item label="最大可销售数量" prop="orderLimitSales">
        <div class="mainum">
          <el-input class="mainum_input" type="number" v-model="ruleForm.orderLimitSales"></el-input>
          {{ unit }}
        </div>
      </el-form-item>

      <div class="entery_title">
        <div class="line"></div>
        <div class="base_title">规格参数</div>
        <div class="fuwenben">(如果现有产品属性无法满足需求，可添加产品属性)</div>
      </div>

      <el-form>
        <div class="parameter_top" v-for="(item, index) in parameters" :key="index">
          <el-form-item>
            <el-input class="shuxi" placeholder="产品属性(最多十个字符)" v-model="item.key" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input class="number" placeholder="请输入值(最多60个字符)" v-model="item.value" maxlength="60"></el-input>
          </el-form-item>
          <el-button type="danger" @click="handleClose(item, index)" icon="el-icon-delete"></el-button>
        </div>
      </el-form>

      <el-button class="addShuxing" type="primary" icon="el-icon-plus" @click="open">添加自定义产品属性</el-button>

      <div class="entery_title">
        <div class="line"></div>
        <div class="base_title">商品详情</div>
        <div class="fuwenben">（高度：3000px以下；宽度：750px以上；图片格式：JPG/JPEG/PNG；大小：小于10MB)</div>
      </div>

      <div class="uploadImg">
        <upload ref="upload" :imgList="imgList"></upload>
      </div>

      <el-form-item class="btn" label-width="25px">
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <!-- <el-button @click="preview('ruleForm')">预览</el-button> -->
      </el-form-item>
    </el-form>

    <addmodel ref="addmodel" @thumbnail="thumbnail"></addmodel>

    <preview class="preview" :threeD="threeD" :imageList="imageList" :ruleForm="ruleForm" :list="imgList" ref="preview">
    </preview>
  </div>
</template>

<script>
import upload from "./upload";
import addmodel from "./addmodel";
import preview from "./preview";
import GlobalUtil from "@/utils/globalUtil.js";
import globalUtil from "../../../utils/globalUtil";

export default {
  components: {
    addmodel,
    preview,
    upload
  },
  data() {
    var validateCustRetail = (rule, value, callback) => {
      let reg = /^\d*\.{0,1}\d{0,9999999}$/
      if (!value) {
        return callback(new Error('请输入销售单价'))
      } else if (parseFloat(value) == 0) {
        return callback(new Error('请输入正确的销售单价'))
      } else if (!reg.test(value)) {
        return callback(new Error('请输入正确的销售单价'))
      } else if (Number(value) < 0.01) {
        return callback(new Error('请输入正确的销售单价'))
      }
      callback()
    }
    var validateMainImgs = (rule, value, callback) => {
      if (!this.ruleForm.mainImgs) {
        return callback(new Error('请上传图片'))
      }
      callback()
    }
    var validateorderLimitSales = (rule, value, callback) => {
      let reg = /^[0-9]*$/g
      if (value) {
        if (value == '0') {
          return callback(new Error('请输入正确的销售数量'))
        } else if (!reg.test(value)) {
          return callback(new Error('请输入正确的销售数量'))
        } else if (Number(value) > 500) {
          return callback(new Error('请输入小于500的值'))
        }
        callback()
      } else {
        return callback('请输入销售数量')
      }

    }
    return {
      imageList: [],
      offRetailStore: false,
      form: {
        key: "",
        value: ""
      },
      ruleForm: {
        offCustRetail: true,
        offDistribution: false,
        distributionType: 2
      },
      cutCustRetail: true,
      rules: {
        name: [
          { required: true, message: "商品名称", trigger: "blur" },
          { min: 1, max: 40, message: "长度不能超过40个字符", trigger: "blur" }
        ],
        ctgId: [{ required: true, message: "请选择商品类型", change: "blur" }],
        mainImgs: [{ validator: validateMainImgs, required: true, trigger: "blur" }],
        mmUnit: [
          { required: true, message: "请选择计算单位", trigger: "blur" }
        ],
        custRetail: [
          { validator: validateCustRetail, required: true, trigger: "blur" }
        ],
        orderLimitSales: [
          {
            validator: validateorderLimitSales,
            required: true,
            trigger: "blur"
          }
        ]
      },
      parameters: [],
      list: [], // 类目列表
      threeD: {}, // 3D图片的地址
      imgList: [], // 详情图片的地址数组
      addOrEditor: true, // 编辑还是新增
      unitList: [] // 商品单位列表
    };
  },
  computed: {
    unit() {
      switch (this.ruleForm.mmUnit) {
        case 'TAO':
          return '套';
          break;
        case 'JIA':
          return '架';
          break;
        case 'JIAN':
          return '件';
          break;
        case 'GE':
          return '个';
          break;
        case 'TAI':
          return '台';
          break;
        case 'XIANG':
          return '箱';
          break;
        default:
          return '个';
      }
    }
  },
  methods: {
    // 预览按钮点击事件
    preview(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$refs.preview.isShow = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除上传图像的图标
    delIcon(index) {
      this.imageList.splice(index, 1);
      if (this.imageList && this.imageList.length > 0) {
        this.ruleForm.mainImgs = JSON.stringify(this.imageList)
      } else {
        this.ruleForm.mainImgs = null
      }
    },
    // 规格参数删除按钮
    handleClose(item, index) {
      // console.log(item);
      // var index = this.parameters.indexOf(item);
      if (index !== -1) {
        this.parameters.splice(index, 1);
      }
    },
    // 关联3D模型
    addModel_show() {
      // 调用接口
      this.$axios.get(this.$url.verify51Config).then(res => {
        if (!res.data) {
          this.$message.error("未配置51账号");
        } else {
          this.$refs.addmodel.query()
        }
      });
    },
    // 提交按钮
    submitForm(formName) {
      if (this.ruleForm.offCustRetail) {
        this.ruleForm.offCustRetail = true
      } else {
        this.ruleForm.offCustRetail = false
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          //处理空的对象
          let params = [];
          for (let item of this.parameters) {
            if (item.key && item.value) {
              params.push(item);
            }
          }
          this.parameters = params;
          // 将规格转为JSON字符串
          this.ruleForm.sizesJson = JSON.stringify(this.parameters);
          // 校验分销类型和金额不能为空
          if (this.offRetailStore) {
            if (this.ruleForm.offDistribution) {
              if (this.ruleForm.distribution == undefined || this.ruleForm.distributionType == undefined) {
                this.$message({
                  message: '分销类型和分销金额不能为空',
                  type: 'warning'
                });
                return;
              }
            }
          } else {
            this.ruleForm.offDistribution = false
          }

          if (this.ruleForm.distributionType == 1) {
            this.ruleForm.distribution = this.ruleForm.distribution / 100;
          }
          // 获取详情图片
          this.getdetail();
          // 判断新增还是编辑
          if (this.addOrEditor) {
            // 新增
            this.$axios.post(this.$url.goodsadd, this.ruleForm).then(res => {
              console.log("我是新增商品", res);
              if (res.code === 0) {
                this.$message.success("新增成功");
                this.$router.back();
              }
            });
          } else {
            // 编辑
            this.$axios.post(this.$url.goodsupdata, this.ruleForm).then(res => {
              console.log("我是编辑商品", res);
              this.$message.success("编辑成功");
              this.$router.back();
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 自定义上传
    uploadSectionFile(file) {
      console.log(file);
      let self = this;
      globalUtil.verifyImgWidthAndHeight(
        file.file,
        cfile => {
          let formData = new FormData();
          let fileName = cfile.name;
          let suffix = fileName.substring(fileName.lastIndexOf(".") + 1);
          formData.append("suffix", suffix);
          formData.append("file", cfile);
          self.uploadFiles(formData, fileName);
        },
        // width => {
        //   if (width !== 750) {
        //     this.$message.error("请上传750*750的图片");
        //     return true;
        //   }
        // },
        // height => {
        //   if (height !== 750) {
        //     this.$message.error("请上传750*750的图片");
        //     return true;
        //   }
        // }
      );
    },
    //  企业简介上传文件
    uploadFiles(file, fileName) {
      console.log("22", file, fileName);
      this.$axios.post(this.$url.uploadFile, file).then(res => {
        if (res.code === 0) {
          // 展示图片
          console.log("上传成功", res);
          this.imageList.push(res.data);
          console.log(res.data)
          // 将图片路径转为JSON字符串格式 添加到ruleForm
          this.$refs.ruleForm.clearValidate();
          this.ruleForm.mainImgs = JSON.stringify(this.imageList);
          console.log(this.ruleForm)
        }
      });
    },
    // 上传前
    beforeAvatarUpload(file) {
      let fileType = ["image/jpeg", "image/png", "image/jpg"];
      const isJPG = fileType.indexOf(file.type) > -1;

      if (!isJPG) {
        this.$message.error("上传图片只能是JPG/PNG格式!");
        return false;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }
      if (this.imageList.length >= 5) {
        this.$message.error("上传数量不能超过5张");
        return false;
      }
      return true;
    },
    // 添加自定义产品属性
    open() {
      this.parameters.push(JSON.parse(JSON.stringify(this.form)));
    },
    // 获取类目列表
    categoryList() {
      this.$axios.post(this.$url.categoryList, {}).then(res => {
        console.log("新增列表", res);
        this.list = res.data;
      });
    },
    // 获取3d图地址
    thumbnail(value) {
      this.threeD = value;
      this.ruleForm.r51Url = value.thumbnail;
      this.ruleForm.r51Code = value.code;
    },
    // 获取详情图片
    getdetail() {
      this.imgList = this.$refs.upload.imageList;
      console.log("我是详情图片", this.imgList);
      this.ruleForm.detailsImg = JSON.stringify(this.imgList);
    },
    // 断是新增还是编辑
    addEditor() {
      if (this.$route.query.data == "add") {
        console.log("我是新增");
        this.imgList = [];
      } else {
        console.log("我是编辑");
        this.addOrEditor = false;
        this.ruleForm = GlobalUtil.getSessionStorage("rowData");
        console.log(this.ruleForm, 66666)
        if (this.ruleForm.distributionType == 1) {
          this.ruleForm.distribution = this.ruleForm.distribution * 100;
        }
        this.threeD = {
          browseCount: this.ruleForm.id,
          code: this.ruleForm.r51Code,
          thumbnail: this.ruleForm.r51Url
        };
        this.imageList =
          typeof this.ruleForm.mainImgs == "string"
            ? JSON.parse(this.ruleForm.mainImgs)
            : [];
        this.parameters =
          typeof this.ruleForm.sizesJson == "string"
            ? JSON.parse(this.ruleForm.sizesJson)
            : [];
        this.imgList =
          typeof this.ruleForm.detailsImg == "string"
            ? JSON.parse(this.ruleForm.detailsImg)
            : [];
      }
    },
    // 获取商品单位列表
    getUnitList() {
      this.$axios.get(this.$url.getUnitList, {}).then(res => {
        console.log("商品单位列表", res);
        if (res.code == 0) {
          this.unitList = res.data;
        }
      });
    },
    // 获取是否展示分销
    getWebInfoAll() {
      let entCode = localStorage.getItem('entCode');
      this.$axios.get(this.$url.getWebInfo, { entCode: entCode })
        .then(res => {
          this.offRetailStore = res.data.offDistribution
        });
    },
  },
  created() {
    // 调用获取类目列表接口
    this.categoryList();
    // 判断是新增还是编辑
    this.addEditor();
    // 调用商品列表接口
    this.getUnitList();
    // 是否展示分销
    this.getWebInfoAll()
  },
  destroyed() {
    GlobalUtil.removeSessionStorage("rowData");
  }
};
</script>

<style lang='less' scoped>
.entryGoods {
  position: relative;
  width: 100%;
  padding: 30px;
  background: #ffffff;
  box-sizing: border-box;
}

.preview {
  position: absolute;
  top: 30px;
  right: 80px;
}

::v-deep .el-input__inner {
  height: 36px !important;
}

.btn {
  margin-top: 100px;
}

.el-icon-error {
  position: absolute;
  right: -10px;
  color: aqua;
  cursor: pointer;
  font-size: 20px;
  top: -10px;
}

.avatar-uploader {
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 3px;
  width: 100px;
  height: 100px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  height: 100px;
  padding-top: 24px;
  box-sizing: border-box;
  color: #999999;
  font-size: 14px;

  &:hover {
    color: rgba(89, 204, 225, 1);
  }
}

.codeInfo {
  line-height: 25px;
  position: absolute;
  bottom: 0px;
  left: 175px;
}

.parameter_top {
  margin-left: 20px;
  box-sizing: border-box;
  display: flex;

  ::v-deep .shuxi {
    .el-input__inner {
      width: 188px !important;
    }

    width: 188px !important;
    margin-right: 16px;
  }

  ::v-deep .number {
    .el-input__inner {
      width: 320px !important;
    }

    width: 320px !important;
    margin-right: 16px;
  }

  ::v-deep .el-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px !important;
    height: 36px !important;
  }
}

.uploads {
  display: flex;
  margin-top: 10px;

  .li_upload {
    position: relative;
    margin-left: 16px;

    &:hover {
      color: rgba(89, 204, 225, 1);
    }
  }
}

.addShuxing {
  margin-bottom: 35px;
  margin-left: 20px;
}

.mainum {
  display: flex;
}

.good_model_itme {
  cursor: pointer;
  height: 112px;
  width: 160px;
  display: flex;
  color: #999999;
  flex-direction: column;
  justify-content: center;
  margin-right: 10px;
  align-items: center;
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 3px;
}

.good_model_itme:hover {
  color: rgba(89, 204, 225, 1);
}

.good_model_img {
  height: 112px;
  width: 160px;
  position: relative;

  &:hover {
    .maskBox {
      display: block;
    }
  }
}

.maskBox {
  height: 112px;
  width: 160px;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.5;
  border-radius: 3px;
  color: #fff;
  text-align: center;
  line-height: 112px;
  display: none;
  cursor: pointer;
}

.good_model {
  height: 112px;
  display: flex;
}

.phone_info {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}

.entery_title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .line {
    width: 3px;
    height: 19px;
    margin-right: 5px;
    background: rgba(102, 102, 102, 1);
  }

  .base_title {
    font-size: 18px;
    font-weight: bold;
    margin-right: 5px;
    color: rgba(51, 51, 51, 1);
  }

  .fuwenben {
    font-size: 14px;
    font-weight: 400;
    color: rgba(245, 108, 108, 1);
  }
}

.cross {
  display: flex;
  align-items: center;
}

.el-input {
  width: 320px;
}

::v-deep .el-input__inner,
::v-deep .el-input--suffix {
  width: 320px !important;
  margin-right: 50px;
}

.mainum_input {
  margin-right: 10px;

  /ddep/ .el-input__inner {
    width: 272px !important;
  }
}
</style>
